import Service, { inject as service } from '@ember/service';

export default class StashedDataCommands extends Service {
  @service api;
  @service shData;
  @service store;

  /**
   * @param jsonData
   * 
   * @returns {*}
   */
  createStashedDirectAssignmentDraft(jsonData) {
    const options = {
      jsonData
    };

    return this.api.post('stashed-data/direct-assignment-draft', options).then(response => {
      this.shData.pushResponseToStore(response);
      return this.store.peekRecord('stashedRecord', response.data.id);
    });
  }

  /**
   * @param company_id
   * @param company_name
   * @param department
   * @param job_title
   * 
   * @returns {*}
   */
  createStashedCompanyJoinProposal(user_id, company_id, company_name, department, job_title) {
    const options = {
      jsonData: {
        department,
        job_title
      }
    };

    if (company_id) {
      options.jsonData['company_id'] = company_id;
    }

    if (company_name) {
      options.jsonData['company_name'] = company_name;
    }

    return this.api.post(`/users/${user_id}/stashed-data/company-join-proposal`, options).then(response => {
      this.shData.pushResponseToStore(response);
      return this.store.peekRecord('stashedRecord', response.data.id);
    });
  }

    /**
   * @param user_id
   * @param company_id
   * @param company_name
   * @param department
   * @param job_title
   * 
   * @returns {*}
   */
    updateStashedCompanyJoinProposal(user_id, company_id, company_name, department, job_title) {
      const options = {
        jsonData: {
          department,
          job_title
        }
      };
  
      if (company_id) {
        options.jsonData['company_id'] = company_id;
      }
  
      if (company_name) {
        options.jsonData['company_name'] = company_name;
      }
  
      return this.api.put(`/users/${user_id}/stashed-data/company-join-proposal`, options).then(response => {
        this.shData.pushResponseToStore(response);
        return this.store.peekRecord('stashedRecord', response.data.id);
      });
    }

  /**
   * @param uuid
   * 
   * @returns {*}
   */
  getByUUID(uuid) {
    return this.api.get(`stashed-data/${uuid}`).then(response => {
      this.shData.pushResponseToStore(response);
      return this.store.peekRecord('stashedRecord', response.data.id);
    });
  }

  /**
   * @param uuid
   * @param user_id
   * 
   * @returns {*}
   */
  assignUserToStashedData(uuid, user_id) {
    const options = {
      jsonData: {
        user_id
      }
    }

    return this.api.put(`stashed-data/${uuid}`, options).then(response => {
      this.shData.pushResponseToStore(response);
      return this.store.peekRecord('stashedRecord', response.data.id);
    });
  }
}
